<script>
  export let sentence
</script>

<div>
  {sentence}
</div>

<style>
  div {
    display: inline;
    user-select: none;
  }
</style>
